const updateSubscriptionSteps = {
  productStep: 'product',
  planStep: 'plan',
  paymentStep: 'payment',
};

export default updateSubscriptionSteps;
